export const selectedPropertyStorageKey = 'selectedPropertyId';
